module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/notes-e35069d86898c19e286245edd1822e5d.svg";